(() => {
  function initStickyRecallBar(bar) {
    const sectionId = bar.dataset.sectionId;
    const anchor = document.querySelector(`#MainProduct-${sectionId} .main-prod-imgs`);
    if (!anchor) return;

    const spacer = bar.previousElementSibling && bar.previousElementSibling.hasAttribute('data-sticky-recall-spacer')
      ? bar.previousElementSibling
      : null;

    const scrollButton = bar.querySelector('[data-sticky-recall-scroll-top]');
    if (scrollButton) {
      scrollButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isVisible = !entry.isIntersecting;
          bar.classList.toggle('product-sticky-recall-bar--visible', isVisible);
          if (spacer) {
            spacer.style.height = isVisible ? `${bar.offsetHeight}px` : '0px';
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    initDeliveryText(bar);
  }

  function initDeliveryText(bar) {
    const promptEl = bar.querySelector('[data-sticky-recall-pincode-prompt]');
    const valueEl = bar.querySelector('[data-sticky-recall-delivery-value]');
    const sourceEl = document.querySelector('delivery-time #time1');
    if (!promptEl || !valueEl || !sourceEl) return;

    function syncDeliveryText() {
      const raw = sourceEl.textContent.trim();
      const hasDelivery = raw.length > 0;
      if (hasDelivery) {
        valueEl.textContent = raw
          .split('.')[0]
          .replace(/^get it\s*(in|by|today)?\s*/i, '')
          .replace(/^(free\s+)?delivery\s*by\s*/i, '')
          .trim();
      }
      valueEl.hidden = !hasDelivery;
      promptEl.hidden = hasDelivery;
    }

    syncDeliveryText();
    new MutationObserver(syncDeliveryText).observe(sourceEl, { childList: true, characterData: true, subtree: true });

    promptEl.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const pincodeInput = document.querySelector('#pincode__input');
      if (pincodeInput) {
        pincodeInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function init() {
    document.querySelectorAll('.product-sticky-recall-bar').forEach(initStickyRecallBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
